// extracted by mini-css-extract-plugin
export default {"container":"SimpleExpander_container__Cpa30"};